<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Manage Pass Blocking Date</h3>
                </div>
                <div class="col-auto float-right ml-auto">
                    <button class="btn add-btn" @click="add">
                        <i class="fa fa-plus"></i>New Pass Blocking Date
                    </button>
                    <button class="btn remove-btn mr-3" @click="remove" :disabled="isDeleteButtonDisabled">
                        <i class="fa fa-trash mr-1"></i>Delete Selected
                    </button>

                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Filter -->
        <div class="row align-items-center">
            <div class="col-md-1" style="max-width:110px">Company</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="company" @change="onCompanyChanged">
                    <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                        {{ item.CompanyName }}
                    </option>
                </select>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-1" style="max-width: 90px">Pass</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="passId">
                    <option value="">All</option>
                    <option v-for="(item, i) in passes" :key="i" :value="item.Id">
                        {{ item.Name }}
                    </option>
                </select>
            </div>
        </div>

        <div class="row align-items-center mt-2">
            <div class="col-md-1" style="max-width:110px">Date From</div>
            <div class="col-md-2 pl-md-0 fit-content">
                <input type="date" class="form-control" v-model="fromDate" />
            </div>
            <div class="col-md-1 fit-content px-1">To</div>
            <div class="col-md-2 fit-content">
                <input type="date" class="form-control" :min="fromDate" v-model="toDate" />
            </div>
            <div class="col-md-2 pl-md-0">
                <button v-if="fromDate || toDate" type="button" class="btn btn-secondary" @click="resetDate">
                    Reset Date
                </button>
            </div>

            <div class="col-md-1" style="margin-left: 20px;">
                <button type="button" class="btn btn-primary" @click="search">Search</button>
            </div>
        </div>
        <!-- /Filter -->

        <!-- Table -->
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <table class="table table-bordered custom-table mb-0" style="width:100%">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-center" style="width: 1%">
                                    <input type="checkbox" v-model="checkAll" @change="toggleCheckAll($event)" />
                                </th>
                                <th>Pass</th>
                                <th style="width:20%">Start Date</th>
                                <th style="width:20%">End Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in records" :key="item.Id">
                                <td class="text-center">
                                    <input type="checkbox" v-model="item.IsSelected" @change="onItemCheckChanged" />
                                </td>
                                <td class="link-underline">
                                    <router-link :to="{
                                      name: 'managePassBlockingDateEdit',
                                      params: { id: item.Id },
                                    }">
                                        {{ item.PassName + ' (' + item.PassCode + ')' }}
                                    </router-link>
                                </td>
                                <td>{{ item.StartDateDisplay }}</td>
                                <td>{{ item.EndDateDisplay }}</td>
                            </tr>
                            <tr v-if="records && !records.length">
                                <td colspan="5" class="text-center">
                                    {{ this.noRecordText }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            records: [],
            companies: [],
            company: config.DEFAULT_COMPANY,
            passes: [],
            passId: "",
            fromDate: "",
            toDate: "",
            noRecordText: config.NO_RECORD_TEXT,
            checkAll: false,
            selectedIds: []
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isDeleteButtonDisabled() {
            for (let item of this.records) {
                if (item.IsSelected) return false;
            }
            return true;
        }
    },

    methods: {
        //filter
        resetDate() {
            this.fromDate = "";
            this.toDate = "";
        },
        onCompanyChanged() {
            this.getPasses();
            this.passId = "";
        },
        getCompanies() {
            let param = {
                Token: this.token
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getPasses() {
            let param = {
                Token: this.token,
                Company: this.company
            }
            this.$store.state.isLoading = true;
            API.getCorporatePass(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.passes = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //table
        getCorporatePassBlockingDates() {
            this.checkAll = false;
            let param = {
                Token: this.token,
                Company: this.company,
                PassId: this.passId,
                FromDate: this.fromDate,
                ToDate: this.toDate
            }
            this.$store.state.isLoading = true;
            API.getCorporatePassBlockingDates(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.records = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        toggleCheckAll($event) {
            let isChecked = $event.target.checked;
            for (let item of this.records) {
                item.IsSelected = isChecked;
            }
        },
        onItemCheckChanged() {
            let allItemChecked = true;
            for (let item of this.records) {
                if (!item.IsSelected) {
                    allItemChecked = false;
                    break;
                }
            }
            this.checkAll = allItemChecked;
        },
        //action
        add() {
            this.$router.push({ name: "managePassBlockingDateAdd" });
        },
        remove() {
            let param = {
                Token: this.token,
                Ids: this.records.filter(c => c.IsSelected == true).map(c => c.Id)
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to delete the selected pass blocking date?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willDelete) => {
                if (willDelete) {
                    this.$store.state.isLoading = true;
                    API.deleteCorporatePassBlockingDate(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.getCorporatePassBlockingDates();
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },
        search() {
            this.getCorporatePassBlockingDates();
        }
    },

    created() {
        if (this.role != "admin") {
            this.$router.replace({ name: "home" });
        }
        this.getCompanies();
        this.getPasses();
        this.getCorporatePassBlockingDates();
    }
}
</script>

<style scoped>
.remove-btn {
    background-color: #dc3545;
    border: 1px solid #dc3545;
    border-radius: 50px;
    color: #fff;
    float: right;
    font-weight: 500;
    min-width: 140px;
}

.link-underline a:hover {
    text-decoration: underline;
}

.fit-content {
    max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/ManagePassBlockingDate.vue